import React, { useState, useEffect } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Logout from "components/Logout";
import Button from "components/CustomButtons/Button.js";
import { TextField } from "@material-ui/core";
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "components/Snackbar/Snackbar.js";
const { API_URL } = require("../../consts");
const { getAutenticado, postAutenticado } = require("../../js_utils/util");

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

export default function UserProfile() {
  let [NOME, setNome] = useState("...");
  let [LOGIN, setLogin] = useState("...");
  let [logado, setLogado] = useState(true);
  let [mensagemErro, setMensagemErro] = useState("");
  const [senha, setSenha] = useState("");
  const [senhaConf, setSenhaConf] = useState("");
  const [mudaSenha, setMudaSenha] = useState(1);
  const [alerta, setAlerta] = useState(false);
  const classes = useStyles();
  const [cor, setCor] = useState("warning");
  const handleAlteracao = (e) => {
    const { name, value } = e.target;
    if (name === "senha") setSenha(value);
    if (name === "confSenha") setSenhaConf(value);
  };
  const showNotification = () => {
    if (!alerta) {
      setAlerta(true);
      setTimeout(function () {
        setAlerta(false);
      }, 6000);
    }
  };

  const alterasenha = async () => {
    try {
      await postAutenticado(API_URL + "alterasenha", {
        password: senha,
        passwordConfirm: senhaConf,
      });
      setCor("success");
      setMensagemErro("Senha alterada!");
      showNotification();
    } catch (err) {
      setCor("danger");
      if (err.response) setMensagemErro(err.response.data.mensagem);
      else setMensagemErro("Algo deu errado. Tente mais tarde");
      showNotification();
    } finally {
      setMudaSenha(1);
    }
  };

  const fragmentoMudaSenha = (
    <GridItem xs={12} sm={12} md={8}>
      <Card>
        <CardHeader color="primary">
          <h5 className={classes.cardTitleWhite}>Alterar senha</h5>
        </CardHeader>
        <CardBody>
          <Button
            onClick={() => {
              setMudaSenha(2);
            }}
          >
            CLique aqui para alterar a sua senha de acesso
          </Button>
        </CardBody>
      </Card>
    </GridItem>
  );

  const fragmentoExecutaMudaSenha = (
    <GridItem xs={12} sm={12} md={8}>
      <Card>
        <CardHeader color="primary">
          <h5 className={classes.cardTitleWhite}>Alterar senha</h5>
        </CardHeader>
        <CardBody>
          <TextField
            type="password"
            className={classes.campoSenha}
            label="Nova senha"
            name="senha"
            onChange={handleAlteracao}
          />

          <TextField
            type="password"
            className={classes.campoSenha}
            label="Confirma senha"
            name="confSenha"
            onChange={handleAlteracao}
          />
          <Button onClick={alterasenha}> Alterar senha</Button>
        </CardBody>
      </Card>
    </GridItem>
  );

  useEffect(async () => {
    let resultado;
    try {
      resultado = await getAutenticado(API_URL + "meusdados");
      resultado = resultado.data.admin;
      setNome(resultado.NOME);
      setLogin(resultado.LOGIN);
    } catch (error) {
      console.log(error);
      console.log(JSON.stringify(resultado));
      if (error.response && error.response.status == 401) setLogado(false);
    }
  }, []);
  return logado ? (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="primary">
              <h5 className={classes.cardTitleWhite}>Administrador</h5>
              <p className={classes.cardCategoryWhite}>{NOME}</p>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={6}>
                  <h3>Usuário:</h3>
                  <h5>{NOME}</h5>
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                  <h3>Login:</h3>
                  <h5>{LOGIN}</h5>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
        {mudaSenha == 1 ? fragmentoMudaSenha : fragmentoExecutaMudaSenha}
      </GridContainer>
      <Snackbar
        place="bc"
        color={cor || "warning"}
        icon={AddAlert}
        message={mensagemErro}
        open={alerta}
        closeNotification={() => setAlerta(false)}
        close
      />
    </div>
  ) : (
    <Logout></Logout>
  );
}
